import PropTypes from 'prop-types';
import { ModelPropType } from '../ModelPropTypes';

const ComponentPropTypes = {
  model: ModelPropType,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool
};

export default ComponentPropTypes;
